/** Breadcrumb trail.
 *
 *  Replaces two hand-rolled trails whose current-page segment used
 *  text-gray-700 — 1.9:1 against the dark surface, effectively invisible.
 */
import React from "react";
import { useNavigate } from "react-router-dom";

export interface Crumb {
  label: string;
  /** Omit on the final (current) crumb. */
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const navigate = useNavigate();

  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-content-muted">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${item.label}-${i}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <button
                  type="button"
                  onClick={() => navigate(item.to as string)}
                  className="rounded hover:text-accent hover:underline underline-offset-2"
                >
                  {item.label}
                </button>
              ) : (
                <span
                  className={isLast ? "font-medium text-content" : undefined}
                  aria-current={isLast ? "page" : undefined}
                >
                  {item.label}
                </span>
              )}
              {!isLast ? (
                <span aria-hidden="true" className="text-content-subtle">
                  /
                </span>
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
